import * as z from "zod";

export const StationReportSummarySchema = z
    .object({
        stationId: z.number(),
        stationName: z.string().trim(),
        icon: z.string().trim(),
    })
    .brand<"StationReportSummary">();
